import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import MuiListNativeStyled from "@/src/components/List/MuiListNativeStyled";
import { Link } from "react-router";

const PrivacyPolicyUpdateDetails = () => {
  return (
    <Grid container rowSpacing={2} sx={{ padding: "20px 0px" }}>
      <Grid>
        <Typography>
          Wir haben unsere Datenschutzerklärung aktualisiert, um Ihnen noch mehr Transparenz über die Verarbeitung Ihrer personenbezogenen Daten zu bieten. Die
          Änderungen treten am 26.08.2025 in Kraft.
          <br />
          <br />
          <strong>Wesentliche Änderungen:</strong>
        </Typography>
      </Grid>
      <Grid>
        <MuiListNativeStyled
          listItems={[
            <>
              <strong>Einsatz von KI zur Unterstützung der Mandatsbearbeitung:</strong>
              <br />
              Wir haben die Angaben zu den von uns eingesetzten KI-gestützten Technologien und deren Nutzung für unsere anwaltlichen Dienstleistungen
              präzisiert.
            </>,
          ]}
        />
      </Grid>
      <Grid>
        <MuiListNativeStyled
          listItems={[
            <>
              <strong>Umfassende Informationen zu Datenübermittlung und Schutzmaßnahmen</strong>
              <br />
              Wir haben unsere Erklärung um genaue Angaben zu den Prozessen und Übertragungswegen ergänzt, mit denen wir die Vertraulichkeit und Sicherheit
              Ihrer Daten gewährleisten.
            </>,
          ]}
        />
      </Grid>
      <Grid>
        <Typography>
          Weitere Infos finden Sie in der{" "}
          <Link target={"_blank"} to={"/datenschutz"}>
            Datenschutzerklärung der Legalbird Rechtsanwälte Rechtsanwalts GmbH
          </Link>{" "}
          und der{" "}
          <Link target={"_blank"} to={"/datenschutz-legalbird"}>
            Datenschutzerklärung der Legalbird GmbH
          </Link>
          .
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PrivacyPolicyUpdateDetails;
